import { DataPath } from '@repperjs/shared/src/@types/DataPath';
import { route } from '../../constants.ts';
import { createAction } from '@reduxjs/toolkit';

export const updateScenes = createAction<{ path: DataPath; value: any }>(`${route}/UPDATE_SCENES`);
